import { useState } from 'react';
import { Outlet } from 'react-router';

import { SkipLink } from '@/components/SkipLink';
import { ClientSidebar } from '@/components/client/ClientSidebar';
import { ClientTopbar } from '@/components/client/ClientTopbar';

/**
 * The client portal's shell — ROADMAP.md §5.1.
 *
 * Deliberately the same skeleton as `AdminLayout`: a fixed sidebar beside a
 * scrolling content column, collapsing to a slide-over below 1024px. One
 * navigation model, not three. What differs is what is *in* it — the user card
 * and sign-out sit at the bottom of the sidebar and the topbar carries a
 * persistent "Request a Cleaning", both from the prototype.
 */
export function ClientLayout() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-ink-50">
      <SkipLink />
      {/* Fixed 224px, desktop only. */}
      <aside className="fixed inset-y-0 left-0 hidden w-56 border-r border-ink-300 bg-white lg:block">
        <ClientSidebar />
      </aside>

      {menuOpen ? (
        <>
          <div
            className="fixed inset-0 z-30 bg-black/40 lg:hidden"
            aria-hidden="true"
            onClick={() => {
              setMenuOpen(false);
            }}
          />
          <aside
            className="fixed inset-y-0 left-0 z-40 w-64 border-r border-ink-300 bg-white lg:hidden"
            // A dialog while it is a slide-over: it traps the page behind it,
            // and saying so is what lets a screen reader treat it as something
            // to dismiss.
            role="dialog"
            aria-modal="true"
            aria-label="Menu"
          >
            <ClientSidebar
              onNavigate={() => {
                setMenuOpen(false);
              }}
            />
          </aside>
        </>
      ) : null}

      <div className="lg:pl-56">
        <ClientTopbar
          onOpenMenu={() => {
            setMenuOpen(true);
          }}
        />
        <main id="main" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
